/**
 * Handles the price calculation when the dedicated button is clicked for a normal cab.
 */
export async function priceCalculationNormal(distanceKm) {
    // Convert km to meters
    const distanceMeter = distanceKm * 1000;

    // Price in centimos (0.0026€ per meter = 0.26 centimos per meter = 2.60€/km)
    let priceCentimos = Math.round(distanceMeter * 0.26);

    // Minimum price of 50 euros
    if (priceCentimos < 5000) {
        priceCentimos = 5000;
    }

    // Convert centimos to euros and centimos
    const euros = Math.round(priceCentimos / 100);
    const remainingCentimos = 0;

    return [euros, remainingCentimos];
}


/**
 * Handles the price calculation when the dedicated button is clicked for a luxury cab.
 */
export async function priceCalculationLuxury(distanceKm) {
    // Convert km to meters
    const distanceMeter = distanceKm * 1000;

    // Price in centimos (0.005€ per meter = 0.5 centimos per meter = 5.00€/km)
    let priceCentimos = Math.round(distanceMeter * 0.5);

    // Minimum price of 50 euros
    if (priceCentimos < 5000) {
        priceCentimos = 5000;
    }

    // Convert centimos to euros and centimos
    const euros = Math.round(priceCentimos / 100);
    const remainingCentimos = 0;

    return [euros, remainingCentimos];
}

/**
 * Handles the price calculation when the dedicated button is clicked for a van cab.
 */
export async function priceCalculationVan(distanceKm) {
    // Convert km to meters
    const distanceMeter = distanceKm * 1000;

    // Price in centimos (0.0035€ per meter = 0.35 centimos per meter = 3.50€/km)
    let priceCentimos = Math.round(distanceMeter * 0.35);

    // Minimum price of 50 euros
    if (priceCentimos < 5000) {
        priceCentimos = 5000;
    }

    // Convert centimos to euros and centimos
    const euros = Math.round(priceCentimos / 100);
    const remainingCentimos = 0;

    return [euros, remainingCentimos];
}
